import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from '../CTAButton';
interface CrossSellModalProps {
  isOpen: boolean;
  emoji: string;
  title: string;
  description: string;
  declineText: string;
  onAccept: () => void;
  onDecline: () => void;
}
export function CrossSellModal({
  isOpen,
  emoji,
  title,
  description,
  declineText,
  onAccept,
  onDecline
}: CrossSellModalProps) {
  return <AnimatePresence data-id="element-297">
      {isOpen && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} data-id="element-298">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-299" />
          <motion.div className="relative bg-white rounded-2xl max-w-md w-full p-8 shadow-2xl text-center" initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} transition={{
        duration: 0.3
      }} data-id="element-300">
            <div className="text-3xl mb-3" data-id="element-301">{emoji}</div>
            <h3 className="text-xl font-heading font-semibold text-text-dark mb-3" data-id="element-302">
              {title}
            </h3>
            <p className="text-sm text-text-medium mb-6" data-id="element-303">{description}</p>

            <div className="flex flex-col gap-3" data-id="element-304">
              <CTAButton text="Sí, agregar todo por $9 más" variant="primary" className="w-full" onClick={onAccept} data-id="element-305" />
              <button onClick={onDecline} className="text-text-medium hover:text-text-dark transition-colors underline underline-offset-4 text-sm font-medium py-2" data-id="element-306">
                {declineText}
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}